import { createMockCreator } from '@csp/test-common-utils';
import { Notification } from '../Notification';

const notificationMock: Notification = {
  message: 'Hello, world!',
  options: { autoHideDuration: 5000 },
};

export const createNotificationMock = createMockCreator(notificationMock);
